module.exports = __webpack_public_path__ + "static/media/anzuro.fff721ed.png";